import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Favorite({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-4 -6 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        className={theme.stroke}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M28.1339152 3.98308837c-6.6393913-6.00772093-12.3575435 1.14718605-12.3575435 1.14718605S10.0582196-2.02463256 3.41882826 3.98308837C-.08484565 7.15285581-.08349783 13.3426698 2.5629587 17.0593907c3.41876087 4.8018605 8.0505652 8.4504651 12.6001522 12.109186.1529782.1220698.3207826.2508838.5168913.2556047.2055435.0040465.3854782-.1301628.5472174-.2569535 4.3285434-3.4159302 8.7413261-6.9087442 12.0239565-11.3943023 2.9382609-4.014814 4.0340435-10.03400002-.1172609-13.78983723z" />
      </g>
    </svg>
  )
}

Favorite.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
